import { Trans } from "react-i18next";

import util from "utils/utils";

import type { NotificationContentProps } from "../../types";

export default function IdeaAddedAsCollaboratorContent({
  events = [],
  ownerIdea,
  ownerChallenge,
  ownerGroup,
  status,
}: NotificationContentProps) {
  return (
    <Trans
      i18nKey="notifications.ideaAddedAsCollaborator"
      values={{
        name: util.getEventNames(events ?? []),
        action: "added",
        idea: ownerIdea?.name || "Deleted",
      }}
    />
  );
}
